export function saleCreditRequest(state={
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_SALE_CREDIT_START":           
        case "FETCH_SALES_CREDITS_START":           
        case "DELETE_SALE_CREDIT_START":           
            return {
                ...state, 
                fetching:true
            }        
        case "CREATE_SALE_CREDIT_FULFILLED":           
        case "FETCH_SALES_CREDITS_FULFILLED":           
        case "DELETE_SALE_CREDIT_FULFILLED":           
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_SALE_CREDIT_ERROR":
        case "FETCH_SALES_CREDITS_ERROR":
        case "DELETE_SALE_CREDIT_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}